import axios from '@axios';
import { ErrorMessage } from '@/libs/Error';

export default class SisDkpClienteClient {
  constructor() {
    this.api = axios;
    this.error = new ErrorMessage();
  }

  async getDkpClientes(queries = {}) {
    try {
      const { data } = await this.api.get('/dkp-clientes', { params: queries });
      return data;
    } catch (error) {
      throw this.error.message(error, 'Erro ao listar os CLientes');
    }
  }

  async postDkpClientes(body) {
    try {
      const { data } = await this.api.post('/dkp-clientes', body);
      return data;
    } catch (error) {
      throw this.error.message(error, 'Erro ao criar o Cliente');
    }
  }

  async deleteDkpClientesIdSoftDelete(id) {
    try {
      const { data } = await this.api.delete(`/dkp-clientes/${id}/softDelete`);
      return data;
    } catch (error) {
      throw this.error.message(error, 'Erro ao deletar o Cliente');
    }
  }

  async putDkpClientesId(id, body) {
    try {
      const { data } = await this.api.put(`/dkp-clientes/${id}`, body);
      return data;
    } catch (error) {
      throw this.error.message(error, 'Erro ao editar o Cliente');
    }
  }
}
